import RetentionPolicyTagDisplay from 'owa-service/lib/contract/RetentionPolicyTagDisplay';
import owaCommonStrings from 'owa-strings/owa-common-strings';
import { format } from 'owa-strings';

/**
 * Gets the retention duration based on the age limit param
 * @param AgeLimitForRetentionDays
 */
export default function getRetentionDuration({
    AgeLimitForRetentionDays: ageLimitForRetentionDays,
}: RetentionPolicyTagDisplay): string {
    if (!ageLimitForRetentionDays) {
        return null;
    }
    return (
        getDayDurationBasedOnAgeLimit(ageLimitForRetentionDays) ||
        getMonthYearDurationBasedOnAgeLimit(ageLimitForRetentionDays)
    );
}

export function getDayDurationBasedOnAgeLimit(ageLimitForRetentionDays: number): string {
    return ageLimitForRetentionDays == 0
        ? owaCommonStrings.retentionPolicies_periodNeverExpireText
        : ageLimitForRetentionDays < 90
        ? format(
              owaCommonStrings.retentionPolicies_periodText,
              ageLimitForRetentionDays,
              getDayString(ageLimitForRetentionDays)
          )
        : null;
}

export function getMonthYearDurationBasedOnAgeLimit(ageLimitForRetentionDays: number): string {
    const years = Math.floor(ageLimitForRetentionDays / 365);
    const months = Math.floor((ageLimitForRetentionDays % 365) / 30);
    const monthsPart = format(
        owaCommonStrings.retentionPolicies_periodText,
        months,
        getMonthString(months)
    );
    const yearsPart = format(
        owaCommonStrings.retentionPolicies_periodText,
        years,
        getYearString(years)
    );
    return years != 0 && months != 0
        ? format(owaCommonStrings.retentionPolicies_periodYearsMonthsText, yearsPart, monthsPart)
        : years != 0
        ? yearsPart
        : monthsPart;
}

function getDayString(day: number): string {
    return day == 1
        ? owaCommonStrings.daySingularLowercase
        : owaCommonStrings.dayFirstPluralLowercase;
}

function getMonthString(month: number): string {
    return month == 1
        ? owaCommonStrings.monthSingularLowercase
        : owaCommonStrings.monthFirstPluralLowercase;
}

function getYearString(year: number): string {
    return year == 1
        ? owaCommonStrings.yearSingularLowercase
        : owaCommonStrings.yearFirstPluralLowercase;
}
